
import { computed, defineComponent, PropType } from 'vue'
import { prefectures } from '@/lib/prefectures'
import { ShippingAddress } from '@/types/order'

export default defineComponent({
  props: {
    address: {
      type: Object as PropType<ShippingAddress>,
      required: true
    }
  },
  setup (props) {
    const prefectureName = computed(() => {
      return prefectures.find(p => p.code === props.address.prefectureCode)?.name || ''
    })

    return { prefectureName }
  }
})
